var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.31 2.063a1.363 1.363 0 0 0-1.388 0l-3.155 2.284v-.882A3.47 3.47 0 0 0 15.3 0H3.465A3.466 3.466 0 0 0 0 3.465v7.832a3.466 3.466 0 0 0 3.465 3.465h11.831a3.466 3.466 0 0 0 3.466-3.466v-.881l3.156 2.284a1.386 1.386 0 0 0 2.082-1.2v-8.23a1.365 1.365 0 0 0-.69-1.206Zm-6.166 9.233a1.851 1.851 0 0 1-1.848 1.848H3.466a1.851 1.851 0 0 1-1.848-1.848v-7.83c0-1.018.825-1.844 1.847-1.848h11.831c1.018 0 1.843.825 1.848 1.847v7.832Zm5.238-.206-3.62-2.55V6.217l3.62-2.551v7.423Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.795 9.44H4.919a.9.9 0 0 0 0 1.8h1.876a.9.9 0 0 0 0-1.8ZM14.659 3.034a.807.807 0 1 0 0 1.613.807.807 0 0 0 0-1.613Z",
    fill: "#fff"
  })));
};
export default SvgVideo;